jQuery(document).ready(function($) {

  'use strict';

  const MAP_DATA_ATTRIBUTE = 'data-static-map';
  const SIGN_URL_ENDPOINT = 'https://map-api-v4.rdc.moveaws.com/api/Maps/SignUrl';
  const MAP_API_URL = 'https://maps.googleapis.com/maps/api/staticmap';
  const CLIENT_ID = 'glp-mmg';

  /**
   * Sign a static map image URL via the Realtor map signing API.
   *
   * @param {HTMLImageElement} img
   */
  function signMap(img) {
    if (img.dataset.staticMapSigned === 'true') {
      return;
    }

    img.dataset.staticMapSigned = 'true';

    const mapAttributes = JSON.parse(img.getAttribute(MAP_DATA_ATTRIBUTE));
    mapAttributes.key = signMapsConfig.mapsKey;

    $.get(SIGN_URL_ENDPOINT, {
      client_id: CLIENT_ID,
      url: `${MAP_API_URL}?${new URLSearchParams(mapAttributes).toString()}`,
    }).done(function(response) {
      img.src = response.result.signed_url;
    });
  }

  /**
   * Lazy-load and sign static map images when they enter the viewport.
   */
  function observeStaticMaps() {
    const maps = document.querySelectorAll(`img[${MAP_DATA_ATTRIBUTE}]`);

    if (!maps.length) {
      return;
    }

    if (!window.IntersectionObserver) {
      maps.forEach(signMap);
      return;
    }

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          signMap(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '100px',
    });

    maps.forEach(function(img) {
      observer.observe(img);
    });
  }

  $(window).on('load', observeStaticMaps);
});
